import { Component } from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";
import {
  HeadingTextWrapperComponent
} from "../../../shared/components/heading-text-wrapper/heading-text-wrapper.component";
import {ButtonComponent} from "../../../shared/components/button/button.component";

@Component({
  selector: 'app-home-hps-card',
  imports: [
    TranslatePipe,
    HeadingTextWrapperComponent,
    ButtonComponent
  ],
  templateUrl: './home-hps-card.component.html',
  styleUrl: './home-hps-card.component.scss'
})
export class HomeHpsCardComponent {
  openHpsInNewTab(): void {
    window.open('https://healthprosuite.com', '_blank');
  }
}
